



































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Button, Card, Form, FormItem, Input, Select, Option } from 'element-ui';
import NavBar from '@/components/layout/NavBar.vue';
import Callout from '@/components/Callout.vue';

import Pagination from '@/mixins/pagination';

import { billItemService } from '@/services/BillItemService.ts';

// gql
import upsertBillItemTemplate from '@/graphql/mutations/BillItemTemplate/Upsert.gql';

// rules
import rules from '@/rules/rules';

import FetchBillItemTemplates from '@/graphql/queries/FetchBillItemTemplates.gql';

import {
  BillItemTemplateFields,
  BillItemTemplateInput,
  TaxTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    billItemTemplates: {
      query: FetchBillItemTemplates,
      variables() {
        return {
          pagination: {
            page:
              parseInt(this.$route.query.page as string, 10) ||
              this.currentPage,
            per:
              parseInt(this.$route.query.size as string, 10) ||
              this.paginationSize
          }
        };
      },
      update(data) {
        this.totalCount = data.billItemTemplatesPagination.totalCount;
        return data && data?.billItemTemplates;
      },
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 2000
        });
      },
      fetchPolicy: 'cache-and-network'
    }
  },
  components: {
    Callout,
    NavBar,
    'el-button': Button,
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class BillItems extends Mixins(Pagination) {
  billItemTemplates: BillItemTemplateFields[] = [];
  editItemId = '';
  isCreation = false;
  isLoading = false;
  newbillItemTemplate: BillItemTemplateInput = {
    taxType: TaxTypeEnum.no_tax,
    description: '',
    category: ''
  };

  readonly rules = rules;

  $refs!: {
    itemForm: HTMLFormElement;
  };

  async deleteItem(id: string) {
    try {
      this.isLoading = true;

      const response = await billItemService.deleteBillItemTemplate(id);

      if (response) {
        this.$apollo.queries.billItemTemplates.refetch();
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.deleted'),
          time: 2000
        });
      }
    } catch (error) {
      this.alertError();
    } finally {
      this.isLoading = false;
    }
  }

  alertError(error?: string) {
    this.$store.dispatch('Alert/addAlert', {
      type: 'error',
      message: error ? this.$t(`error.${error}`) : this.$t('error.push'),
      time: 2000
    });
  }

  upsertItem(item: any) {
    this.$refs.itemForm.validate(async(valid: boolean) => {
      if (valid && !this.isLoading) {
        try {
          const response = await this.$apollo.mutate({
            mutation: upsertBillItemTemplate,
            variables: {
              biItemTemplateArgs: {
                category: item.category,
                description: item.description,
                taxType: item.taxType,
                templateId: item.id || null
              }
            }
          });

          if (response) {
            // reset form and edition
            this.editItemId = '';
            this.$refs.itemForm.resetFields();
            // refetch
            this.$apollo.queries.billItemTemplates.refetch();
            this.$store.dispatch('Alert/addAlert', {
              type: 'success',
              message: this.$t('success.updated'),
              time: 2000
            });
            this.$emit('createItem', response.data?.upsertBillItemTemplate);
            this.$emit('close');
          }
        } catch (error) {
          this.$store.dispatch('Alert/addAlert', {
            type: 'error',
            message: this.$t('error.push'),
            time: 2000
          });
        } finally {
          this.isLoading = false;
        }
      }
    });
  }
}
